import styled from "styled-components";
import { Button } from "@mui/material/";
import { styled as muiStyled } from "@mui/material/styles/";
import { primaryColor, secondaryColor } from "../../global/constants";

export const Content = styled.div`
  display: flex;
  color: white;
  flex-direction: column;
  height: 90vh;
  justify-content: space-between;
`;

export const ProceedButton = muiStyled(Button)({
  textAlign: "center",
  textTransform: "none",
  fontSize: 16,
  marginTop: "10px",
  padding: "6px 12px",
  height: "50px",
  lineHeight: 1.5,
  backgroundColor: primaryColor,
  border: "none",
  width: "100%",
  "&:hover": {
    backgroundColor: secondaryColor,
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: secondaryColor,
  },
});

export const Loading = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Wait = styled.div`
  margin-top: 5px;
  text-align: center;
`;

export const ItemContent = styled.div`
  height: 70vh;
  display: flex;
  overflow-y: auto;
  flex-direction: column;
  padding: 5% 10% 0 10%;
`;
export const ItemContainer = styled.div`
  overflow-y: auto;
  padding: 0 1% 0 1%;
  border-radius: 20px;
`;

export const TitleBar = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: white;
  padding-bottom: 10px;
  height: 50px;
`;
